export default function useEnvironment() {
  return {
    isProduction: import.meta.env.PROD,
    isDevelopment: import.meta.env.DEV,
  };
}
